module.exports = __webpack_public_path__ + "static/media/gallery-ico.c4df4d5e.svg";